/*
Jquery Plugins

These jquery plugins aim to be used on several levels:

1. firstly with data attributes in your html
2. secondly as html instance methods once instantiated
3. thirdly via event bus

See `Core.Global.Javascript.JqueryPlugin`

```
Todo

[.*]--emit-before=""
[.*]--emit-after=""
[.*]--emit-success=""
[.*]--emit-error=""

data-navigate
data-navigate--on="click"
data-navigate--if=""
data-navigate--url="/some/thing"

```

Styleguide Global.Javascript
*/

import "./jquery__collapsible/plugin--bundled";
import "./jquery__radio-selection/plugin--bundled";
import "./jquery__toggle-element-classes";
import "./jquery__toggle-element-attributes";
// import "./jquery__remove-element-classes";
// import "./jquery__add-element-classes";
// import "./jquery__focus-within";
import "./jquery__focus";
// import "./jquery__emit-on-dirty";
import "./jquery__trigger-event";

// import "./jquery__element-transitions";
// import "./jquery__anchor-element";
// import "./jquery__broadcast-events";
// import "./jquery__analytics-trigger";
// import "./jquery__execute-method";
// import "./jquery__responsive-tables";
// import "./jquery__responsive-video";


// import "./jquery__transport-elements";
// import "./jquery__mediaquery-sensor";
// import "./jquery__ajax-queue";
// import "./jquery__manifest-asset";
// import "./jquery__sticky";
// import "./jquery__truncate-text";
// import "./jquery__prevent-default";
// import "./jquery__stop-propagation";



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/index.js